$(document).ready(function(){
    const tag = location.pathname.split('/')[3];
    if(tag){
        $("[js-product-tag]").removeClass("active");
        $(`[data-product-tag='${tag}']`).addClass('active');
    }
})

"use strict";
var Ajaxinate = function(e) {
    var i = e || {},
        n = {
            pagination: ".AjaxinatePagination",
           // method: "click",
            method: "scroll",
            container: ".AjaxinateLoop",
            offset: 0,
            loadingText: "Loading",
            callback: null,
        };
    this.settings = Object.assign(n, i), 
    this.addScrollListeners = this.addScrollListeners.bind(this), 
    this.addClickListener = this.addClickListener.bind(this), 
    this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this), 
    this.stopMultipleClicks = this.stopMultipleClicks.bind(this), 
    this.destroy = this.destroy.bind(this), 
    this.containerElement = document.querySelector(this.settings.container), 
    this.paginationElement = document.querySelector(this.settings.pagination), 
    
    this.filterAndSortQuerys = {};
    this.initialize()

    // const sortContainer = document.getElementById('collection-sorting');

  
  
    // if(sortContainer) {
    //     const filterOutputWrapper = sortContainer.querySelector('[js-filter-output-wraper]');
    //     const filterlistWrapper = sortContainer.querySelector('[js-filter-list-wraper]');

    //     sortContainer.querySelectorAll('[js-sort-option]').forEach(sortfilterItem => {
    //         sortfilterItem.addEventListener('change', () => {
    //             //filterlistWrapper.style.display = 'none';
    //             filterlistWrapper.classList.remove('open');
    //             document.querySelector('body').classList.remove('open_filter');
    //             const showValue = sortfilterItem.getAttribute('data-show-value');
    //             sortContainer.querySelector('[js-filter-output]').innerHTML = showValue;
    //         })
    //     })
        
    //     filterOutputWrapper.addEventListener('click', () => {
    //       alert('add');
    //         //filterlistWrapper.style.display = 'block';
    //         filterlistWrapper.classList.add('open');
    //         document.querySelector('body').classList.add('open_filter');
    //     });

    // }
    
};
Ajaxinate.prototype.initialize = function() {
    if (this.containerElement) {

        var e = {
            click: this.addClickListener,
            scroll: this.addScrollListeners
        };
        e[this.settings.method]()
    
    }
}, 
Ajaxinate.prototype.addScrollListeners = function() {
    this.paginationElement && (document.addEventListener("scroll", this.checkIfPaginationInView), window.addEventListener("resize", this.checkIfPaginationInView), window.addEventListener("orientationchange", this.checkIfPaginationInView))
    this.checkIfPaginationInView();
}, 
Ajaxinate.prototype.addClickListener = function(e) {
  this.paginationElement && (this.nextPageLinkElement = this.paginationElement.querySelector("a"), this.clickActive = !0, this.nextPageLinkElement !== null && this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks))
}, 
Ajaxinate.prototype.stopMultipleClicks = function(e) {
    e.preventDefault(), 
    this.clickActive && (this.nextPageLinkElement.innerHTML = this.settings.loadingText, this.nextPageUrl = this.nextPageLinkElement.href, this.clickActive = !1, this.loadMore())
}, 
Ajaxinate.prototype.checkIfPaginationInView = function() {
    var e = this.paginationElement.getBoundingClientRect().top - this.settings.offset - 800,
        i = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
    e <= window.innerHeight && i >= 0 && (this.nextPageLinkElement = this.paginationElement.querySelector("a"), this.removeScrollListener(), this.nextPageLinkElement && (this.nextPageLinkElement.innerHTML = this.settings.loadingText, this.nextPageUrl = this.nextPageLinkElement.href, this.loadMore()))
}, 
Ajaxinate.prototype.loadMore = function() {

    const this_ = this;
    const nextPageIndex = this.paginationElement.querySelector('a')?.getAttribute('data-index');
    const nextPageIndexmobile = this.paginationElement.querySelector('a')?.getAttribute('data-index-mobile');
    fetch(`${this.nextPageUrl}&view=ajax-collection&forloop_index=${nextPageIndex}&&forloop_index_mobile=${nextPageIndexmobile}`)
      .then(function(response) {
        return response.text();
      }).then(function(html) {
        // Convert the HTML string into a document object
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var container_ = doc.querySelector(this_.settings.container);
        var pagination_ = doc.querySelector(this_.settings.pagination);

        this_.containerElement.insertAdjacentHTML("beforeend", container_.innerHTML); 
        this_.paginationElement.innerHTML = pagination_.innerHTML;

        /* Card_product_media_gallery_slider */
        new Swiper('.Card_product_media_gallery_slider', {
          loop: true,
          grabCursor: true,
          spaceBetween: 0,
          slidesPerGroup: 1,
          slidesPerView: 1,
          watchSlidesProgress: true,
          draggable:!0,
          autoHeight:!1,
          watchOverflow:!0,
          threshold:10,
          mousewheel:{
            forceToAxis:!0
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }
        })

       if (typeof hideSingleColorSwatches === 'function') {
        hideSingleColorSwatches();
       }

        if(document.querySelector('#collection-counter-wrapper')) {
            let total_products = document.querySelectorAll('[js-product-card-list-item]').length;
    
            if(total_products === 1){
                total_products = `(${total_products}) item`
            } else {
                total_products = `(${total_products}) items`
            }
            
            document.querySelector('#collection-counter-wrapper').innerHTML = total_products;
        }
    
        this_.initialize();
      });
}, 
Ajaxinate.prototype.removeClickListener = function() {
    this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks)
}, 
Ajaxinate.prototype.removeScrollListener = function() {
    document.removeEventListener("scroll", this.checkIfPaginationInView), window.removeEventListener("resize", this.checkIfPaginationInView), window.removeEventListener("orientationchange", this.checkIfPaginationInView)
}, 
Ajaxinate.prototype.destroy = function() {
    var e = {
        click: this.removeClickListener,
        scroll: this.removeScrollListener
    };
    return e[this.settings.method](), this
};

function ajaxLoadMore() {
    new Ajaxinate({
        container: '#custom-collection-product-Loop',
        pagination: '#custom-collection-Pagination'
    });
    new Ajaxinate({
        container: '#custom-blog-container',
        pagination: '#custom-blog-Pagination'
    });
}
ajaxLoadMore();
document.addEventListener('ajaxLoadMore:init', ajaxLoadMore);

document.addEventListener('click', function(e){
    if(!e.target.closest('#collection-sorting') && document.getElementById('collection-sorting')){
        //document.getElementById('collection-sorting').querySelector('[js-filter-list-wraper]').style.display = 'none';
        document.getElementById('collection-sorting').querySelector('[js-filter-list-wraper]').classList.remove('open');
        document.querySelector('body').classList.remove('open_filter');
    }
})

if(document.getElementById('more-filter-btn')) {
    document.getElementById('more-filter-btn').addEventListener('click', function(){
        this.style.display = 'none';
        document.querySelectorAll('[js-filter-more]').forEach(btn => {
            btn.style.display = 'flex';
        })
    })
}



 const sortContainer = document.getElementById('collection-sorting');

if(sortContainer) {
        const filterOutputWrapper = sortContainer.querySelector('[js-filter-output-wraper]');
        const filterlistWrapper = sortContainer.querySelector('[js-filter-list-wraper]');

        sortContainer.querySelectorAll('[js-sort-option]').forEach(sortfilterItem => {
            sortfilterItem.addEventListener('change', () => {
                //filterlistWrapper.style.display = 'none';
                filterlistWrapper.classList.remove('open');
                document.querySelector('body').classList.remove('open_filter');
                const showValue = sortfilterItem.getAttribute('data-show-value');
                sortContainer.querySelector('[js-filter-output]').innerHTML = showValue;
            })
        })
        
        filterOutputWrapper.addEventListener('click', () => {
        
            //filterlistWrapper.style.display = 'block';
            filterlistWrapper.classList.toggle('open');
            document.querySelector('body').classList.toggle('open_filter');
        });

    }